import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { EditManualClientPositionForm } from "./EditManualClientPositionForm";
import { ClientPosition } from "@/lib/api/risk/positions";

interface EditManualClientPositionDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
    position: ClientPosition | null;
}

export function EditManualClientPositionDialog({ isOpen, onClose, onSuccess, position }: EditManualClientPositionDialogProps) {
    const handleSuccess = () => {
        onSuccess();
        onClose();
    };

    if (!position) {
        return null;
    }

    return (
        <Dialog open={isOpen} onOpenChange={(open) => {
            if (!open) {
                onClose();
            }
        }}>
            <DialogContent className="sm:max-w-[90vw] md:max-w-[80vw] lg:max-w-[70vw] max-h-[90vh] overflow-y-auto">
                <DialogHeader>
                    <DialogTitle>Edit Manual Client Position</DialogTitle>
                    <DialogDescription>
                        Update the details for this manual client position entry
                    </DialogDescription>
                </DialogHeader>

                <div className="space-y-6">
                    <EditManualClientPositionForm
                        position={position}
                        onSuccess={handleSuccess}
                        onCancel={onClose}
                        showCancelButton={true}
                    />
                </div>
            </DialogContent>
        </Dialog>
    );
}